import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState } from "react";
import analyse from '../../../assets/image/project-img/analasis.png';
import Api from "../../../assets/image/project-img/API.png";
import fabriLife from "../../../assets/image/project-img/fabriLife (2).png";
import interiorDesign from "../../../assets/image/project-img/interior-design.png";
import powerGym from "../../../assets/image/project-img/PowerGym.png";
import redOnion from "../../../assets/image/project-img/red-onion.png";
import ProjectCard from "./ProjectCard/ProjectCard";


const projects = [
  {
    picture: fabriLife,
    title: "E-commerce Shop",
    text: "Fabrilife is a e-commerce online shop where customer can choose their products and place an order. It is MERN stack project. Firebase authentication applied.",
    time: "2021",
    githubLink: "https://github.com/arif286/fabrilife-E-commerce-client-site",
    liveSite: "https://fabri-life.web.app/home",
    id: 1,
  },
  {
    picture: powerGym,
    title: "Power X Gym",
    text: "A gym center that people can easily exercise and build muscle. This project integrate the stripe payment method to get payment form customer.",
    time: "2020",
    githubLink: "https://github.com/arif286/power-x-gym",
    liveSite: "https://power-x-gym-3.web.app/",
    id: 2,
  },
  {
    picture: redOnion,
    title: "Online Food Shop",
    text: "A web site that lets users choose their best food and order through the internet. This project applied Google Map to deliver food to customer easily.",
    time: "2021",
    githubLink: "https://github.com/arif286/red-onion-client",
    liveSite: "https://red-onion-food-shop.web.app/",
    id: 3,
  },
  {
    picture: interiorDesign,
    title: "Interior Design",
    text: "A platform for house and building design Where user can pick their best service and can discuss about the service their needs. Integrate stripe payment method and used firebase authentication for secure admin panel.",
    time: "2021",
    githubLink: "https://github.com/arif286/home-decoration-client-site",
    liveSite: "https://interior-design-service.web.app/",
    id: 4,
  },
  {
    picture: Api,
    title: "API Integration",
    text: "This projects featured by api integration with web application. In this projects I used The sports db api. Its allows applications to communicate with backend systems. The sports db api is an sport news portal.",
    time: "2021",
    githubLink: "https://github.com/arif286/Api-intergation",
    liveSite: "https://worldclass-supper-league.netlify.app/",
    id: 5,
  },
  {
    picture: analyse,
    title: "Analyse Business",
    text: "This is a Analyse Business website. In this projects I used HTML, CSS, React,Javascript and React Router.Any customer can visit this website and get their best services.",
    time: "2021",
    githubLink: "https://github.com/arif286/Business-webpage",
    liveSite: "https://inspiring-bel.netlify.app/",
    id: 6,
  },
];
const Project = () => {
  const [work, setWork] = useState([]);
  useEffect(() => {
    AOS.init({ duration: 2000 });
    setWork(projects)
  }, []);
  return (
    <div
      data-aos="fade-up"
      id="projects"
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <div>
        <ProjectCard projects={work} />
      </div>
    </div>
  );
};

export default Project;
